/* eslint-disable max-len */
const KTGlobalComponentsConfig = {
  modal: {
    backdropClass: 'transition-all duration-300',
  },
  drawer: {
    backdropClass: 'transition-all duration-300',
    hiddenClass: 'hidden'
  },
  collapse: {
    hiddenClass: 'hidden',
  },
  dismiss: {
    hiddenClass: 'hidden',
  },
  tabs: {
    hiddenClass: 'hidden',
  },
  accordion: {
    hiddenClass: 'hidden',
  },
  ktDropzone: {
    // Users can set any Dropzone.js option here as global defaults
    // These will be merged with _defaultConfig
  }
};

export default KTGlobalComponentsConfig;

